import React from "react";
import Box from "@mui/material/Box";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CDB", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export const AFL_EVENT_COLORS: { [id: string]: string } = {
  "Groundout": "#BDBDBD",
  "Single": "#008000",
  "Double": "#0000FF",
  "Home Run": "#f7eb11",
  "GIDP": "#BDBDBD",
  "Lineout": "#BDBDBD",
  "Flyout": "#BDBDBD",
  "Field Error": "#BDBDBD",
  sac_fly: "#BDBDBD",
  sac_bunt: "#BDBDBD",
  "Triple": "#f42f11",
  double_play: "#BDBDBD",
  fielders_choice_out: "#BDBDBD",
  fielders_choice: "#BDBDBD",
};

export default function AflPitcherStats(props: any) {


  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }


  // Get team colors for styling
  const teamColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][0]
    : teamColors["FA"][0];

  const textColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][1]
    : teamColors["FA"][1];

  const formatPercent = (value: number): string => {
    return value ? `${(value * 100).toFixed(1)}%` : '0.0%';
  };

  const formatNumber = (value: number): string => {
    return value ? value.toFixed(1) : '-';
  };

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
        marginTop={1}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "460px" : "100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor: teamColor,
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color: textColor,
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    AFL Season Stats
                  </span>
                </Typography>
              </Grid>
            </div>

            {props.playerDataProp.ip !== undefined && <TableContainer>
              <Table size="small">
                <TableBody>
                  {/* Traditional Pitching Stats */}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', width: '30%' }}>G</TableCell>
                    <TableCell>{props.playerDataProp.games}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', width: '30%' }}>IP</TableCell>
                    <TableCell>{(parseInt(props.playerDataProp.ip) + ((props.playerDataProp.ip) % 1 / 3).toPrecision(1).toString().substring(1))}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Total Pitches</TableCell>
                    <TableCell>{props.playerDataProp.total_pitches || 0}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>WHIP</TableCell>
                    <TableCell>{props.playerDataProp.whip?.toFixed(2) || '0.00'}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>K/9</TableCell>
                    <TableCell>{props.playerDataProp.k_per_9?.toFixed(1) || '0.0'}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>BB/9</TableCell>
                    <TableCell>{props.playerDataProp.bb_per_9?.toFixed(1) || '0.0'}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Hits</TableCell>
                    <TableCell>{props.playerDataProp.h}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Home Runs</TableCell>
                    <TableCell>{props.playerDataProp.hr}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Walks</TableCell>
                    <TableCell>{props.playerDataProp.bb}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Strikeouts</TableCell>
                    <TableCell>{props.playerDataProp.k}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Batters Faced</TableCell>
                    <TableCell>{props.playerDataProp.pa}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Hit By Pitch</TableCell>
                    <TableCell>{props.playerDataProp.hbp}</TableCell>
                  </TableRow>

                  {/* Advanced Stats */}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Strikeout %</TableCell>
                    <TableCell>{formatPercent(props.playerDataProp.k_percent)}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Walk %</TableCell>
                    <TableCell>{formatPercent(props.playerDataProp.bb_percent)}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>BA Against</TableCell>
                    <TableCell>{props.playerDataProp.ba?.toFixed(3) || '.000'}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>OBP Against</TableCell>
                    <TableCell>{props.playerDataProp.obp?.toFixed(3) || '.000'}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Slugging Against</TableCell>
                    <TableCell>{props.playerDataProp.slg?.toFixed(3) || '.000'}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>K/BB Ratio</TableCell>
                    <TableCell>{(props.playerDataProp.k / props.playerDataProp.bb).toFixed(2)}</TableCell>
                  </TableRow>

                  {/* Pitch Metrics */}
                  <TableRow>

                    <TableCell sx={{ fontWeight: 'bold' }}>Max Velocity</TableCell>
                    <TableCell>{formatNumber(props.playerDataProp.max_velo)} mph</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Max Spin Rate</TableCell>
                    <TableCell>{formatNumber(props.playerDataProp.max_spin_rate)} rpm</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Strike Rate</TableCell>
                    <TableCell>{formatPercent(props.playerDataProp.strike_rate)}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Whiff Rate</TableCell>
                    <TableCell>{formatPercent(props.playerDataProp.whiff_rate)}</TableCell>
                  </TableRow>

                  <TableRow>

                    <TableCell sx={{ fontWeight: 'bold' }}>Strikes</TableCell>
                    <TableCell>{props.playerDataProp.strikes || 0}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Balls</TableCell>
                    <TableCell>{props.playerDataProp.balls || 0}</TableCell>
                  </TableRow>

                  <TableRow>

                    <TableCell sx={{ fontWeight: 'bold' }}>Swings</TableCell>
                    <TableCell>{props.playerDataProp.total_swings || 0}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Whiffs</TableCell>
                    <TableCell>{props.playerDataProp.total_whiffs || 0}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}